import React from 'react';
import PropTypes from 'prop-types';
import { ButtonPill, IconClose } from '@scotia/canvas-react';
import { LoanIcon } from './LoanIcon';
import { IconSubtract } from './IconSubtract';
import cx from 'classnames';
import style from './RealTimeNotification.scss';
import { compose, withState, withHandlers } from 'recompose';

const enhance = compose(
  withState('status', 'setStatus', props => props.initialStatus),
  withHandlers({
    minimizeAction: props => () => {
      if (props.status === 'OPENED') {
        props.setStatus('STANDBY') && props.onMinimize();
      }
    },
    maximizeAction: props => event => {
      event.stopPropagation();
      if (props.status === 'STANDBY') {
        props.setStatus('OPENED') && props.onOpen();
      }
    },
    closeAction: props => event => {
      event.stopPropagation();
      props.setStatus('CLOSED') && props.onClose();
    },
    clickAction: props => () => {
      props.setStatus('CLOSED') && props.onClick();
    }
  })
);

const RealTimeNotification = enhance(
  ({
    greeting,
    previewMessage,
    message,
    amount,
    status,
    maximizeAction,
    minimizeAction,
    closeAction,
    clickAction
  }) => (
    <div
      className={style['rtm__mask']}
      style={{ visibility: status != 'CLOSED' ? 'visible' : 'hidden' }}
    >
      <div
        onClick={maximizeAction}
        className={cx(style.rtm, [style[status.toLowerCase()]])}
      >
        <div className={style.rtmIcon}>
          <LoanIcon />
        </div>
        <div className={style.controls}>
          <div className={style.text}>
            <div className={style.greeting}>{greeting}</div>
            <div className={style.message}>{message}</div>
            <div className={style.previewMessage}>{previewMessage}</div>
            <div className={style.amount}>{`$ ${amount.toLocaleString(
              'es-CL'
            )}`}</div>
          </div>
          <div className={style.button}>
            {status === 'OPENED' && (
              <ButtonPill variant="notification" onClick={clickAction}>
                Lo quiero
              </ButtonPill>
            )}
          </div>
        </div>
        <div className={style.control}>
          <span onClick={minimizeAction} className={style['control__minimize']}>
            <IconSubtract size={24} />
          </span>
          <span onClick={closeAction} className={style['control__close']}>
            <IconClose size={18} />
          </span>
        </div>
      </div>
    </div>
  )
);

RealTimeNotification.propTypes = {
  greeting: PropTypes.string,
  previewMessage: PropTypes.string,
  message: PropTypes.string,
  amount: PropTypes.number,
  initialStatus: PropTypes.oneOf(['OPENED', 'STANDBY', 'CLOSED']).isRequired,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  onMinimize: PropTypes.func
};
RealTimeNotification.defaultProps = {
  greeting: 'Hola',
  previewMessage: 'Tienes un Crédito de Consumo aprobado',
  message: 'Tienes hoy un Crédito de Consumo aprobado de hasta',
  amount: 0,
  onClick: () => {},
  onClose: () => {},
  onOpen: () => {},
  onMinimize: () => {}
};
export { RealTimeNotification };
